import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { TASK_STATUS_COLORS } from '../../constants';
import _ from 'lodash';

const RestaurantsOverview = ({ data }) => {
  const restaurantData =
    data?.map((restaurant) => {
      return {
        name: restaurant?.restaurant_title || '',
        tasks: {
          pending: restaurant?.pending_tasks || 0,
          completed: restaurant?.completed_tasks || 0,
          overdue: restaurant?.overdue_tasks || 0,
        },
      };
    }) || [];

  const chartOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: [TASK_STATUS_COLORS.completed, TASK_STATUS_COLORS.pending, TASK_STATUS_COLORS.overdue],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    xaxis: {
      categories: restaurantData?.map((restaurant) => restaurant?.name),
    },
    yaxis: {
      title: {
        text: 'Tasks Count',
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} Tasks`,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
    },
  };

  const chartSeries = [
    {
      name: 'Completed',
      data: restaurantData?.map((restaurant) => restaurant.tasks.completed),
    },
    {
      name: 'Pending',
      data: restaurantData?.map((restaurant) => restaurant.tasks.pending),
    },
    {
      name: 'Overdue',
      data: restaurantData?.map((restaurant) => restaurant.tasks.overdue),
    },
  ];

  return <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={300} />;
};

export default RestaurantsOverview;
